import * as React from "react";

export type ChatSpinnerProps = {
  size?: "sm" | "md";
};

export const ChatSpinner: React.FC<ChatSpinnerProps> = ({ size = "md" }) => (
  <span className={`chat-spinner chat-spinner--${size}`} aria-hidden />
);
